export const SPLITS_EVENTS = {
  VIEW_SPLITS_LANDING: 'view_splits_landing',
  VIEW_SPLITS_SELECT_MEMBER: 'view_splits_select_member',
  VIEW_SPLITS_CONFIRMATION: 'view_splits_confirmation',
  VIEW_SPLITS_ERROR: 'view_splits_error',
  VIEW_SPLITS_SUCCESS: 'view_splits_success',
  SELECT_SPLITS_MEMBER: 'select_splits_member',
  SELECT_SPLITS_CONTINUE: 'select_splits_continue',
  VIEW_SPLITS_PHONE_INPUT: 'view_splits_phone_input',
  SELECT_SPLITS_PHONE_CONTINUE: 'select_splits_phone_continue',
  VIEW_SPLITS_OTP: 'view_splits_otp',
  SELECT_SPLITS_RESEND_OTP: 'select_splits_resend_otp',
  SELECT_SPLITS_SUBMIT_OTP: 'select_splits_submit_otp',
  SELECT_SPLITS_OPEN_ACCOUNT: 'select_splits_open_account',
  SELECT_SPLITS_BACK_PHONE_INPUT: 'select_splits_back_phone_input',
  SELECT_SPLITS_GO_TO_PAY: 'select_splits_go_to_pay',
  API_SPLITS_GET_DATA_SUCCESS: 'api_splits_get_data_success',
  API_SPLITS_GET_DATA_ERROR: 'api_splits_get_data_error',
  API_SPLITS_CONFIRM_PAYMENT_SUCCESS: 'api_splits_confirm_payment_success',
  API_SPLITS_CONFIRM_PAYMENT_ERROR: 'api_splits_confirm_payment_error',
  API_SPLITS_SAVE_PARTICIPANT_SUCCESS: 'api_splits_save_participant_success',
  API_SPLITS_SAVE_PARTICIPANT_ERROR: 'api_splits_save_participant_error',
  API_SPLITS_VALIDATE_OTP_SUCCESS: 'api_splits_validate_otp_success',
  API_SPLITS_VALIDATE_OTP_ERROR: 'api_splits_validate_otp_error',
  API_SPLITS_RESEND_OTP_SUCCESS: 'api_splits_resend_otp_success',
  API_SPLITS_RESEND_OTP_ERROR: 'api_splits_resend_otp_error',
  API_SPLITS_JOIN_LOGGED_USER_TO_SPLIT_SUCCESS:
    'api_splits_join_logged_user_to_split_success',
  API_SPLITS_JOIN_LOGGED_USER_TO_SPLIT_ERROR:
    'api_splits_join_logged_user_to_split_error',
} as const;
